import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Small, MediumUp } from 'components/MediaQuery';
import VideoPlayer from 'components/VideoPlayer';

const BackgroundVideo = ({ video, paused }) => {
  const landscapeVideo = get(video, 'landscape');
  const portraitVideo = get(video, 'portrait');

  if (!landscapeVideo.src || !portraitVideo.src) {
    return null;
  }

  return (
    <div className="BackgroundVideo order-1 h-full w-full">
      <Small>
        <VideoPlayer
          aspectRatio="4:5"
          url={portraitVideo.src}
          playing={!paused}
          muted
          loop
          playsinline
        />
      </Small>
      <MediumUp>
        <VideoPlayer
          aspectRatio="1:.43"
          url={landscapeVideo.src}
          playing={!paused}
          muted
          loop
          playsinline
        />
      </MediumUp>
    </div>
  );
};

const assetPropType = PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string });

BackgroundVideo.propTypes = {
  video: PropTypes.shape({
    landscape: assetPropType.isRequired,
    portrait: assetPropType,
  }).isRequired,
  paused: PropTypes.bool,
};

BackgroundVideo.defaultProps = {
  paused: false,
};

export default BackgroundVideo;
